import { render, staticRenderFns } from "./BrowserVersionConfig.vue?vue&type=template&id=90752e0e&scoped=true"
import script from "./BrowserVersionConfig.vue?vue&type=script&lang=ts"
export * from "./BrowserVersionConfig.vue?vue&type=script&lang=ts"
import style0 from "./BrowserVersionConfig.vue?vue&type=style&index=0&id=90752e0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90752e0e",
  null
  
)

export default component.exports